(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"), require("mggp-plugin-buffering"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player", "mggp-plugin-buffering"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-html5"] = factory(require("mggp-player"), require("mggp-plugin-buffering"));
	else
		root["mggp-vendor-html5"] = factory(root["mggp-player"], root["mggp-plugin-buffering"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__269__, __WEBPACK_EXTERNAL_MODULE__691__) {
return 